import { FaAlignLeft } from "react-icons/fa";

import { useDashboardContext } from "@/layouts/dashboard-layout";

import { NavbarWrapper } from "@/components/wrappers";

import { Logo, LogoutContainer, ThemeToggle } from ".";

const Navbar = () => {
  const { toggleSidebar } = useDashboardContext();

  return (
    <NavbarWrapper>
      <div className="nav-center">
        <button className="toggle-btn" type="button" onClick={toggleSidebar}>
          <FaAlignLeft />
        </button>
        <div>
          <Logo />
          <h4 className="logo-text">dashboard</h4>
        </div>
        <div className="btn-container">
          <ThemeToggle />
          <LogoutContainer />
        </div>
      </div>
    </NavbarWrapper>
  );
};

export default Navbar;
